import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBuJJOHMK6_RXCMB3rVOKLmzyb-AowxB6c",
  authDomain: "saloon-acaed.firebaseapp.com",
  projectId: "saloon-acaed",
  storageBucket: "saloon-acaed.appspot.com",
  messagingSenderId: "664836267275",
  appId: "1:664836267275:web:e7245968aa614c682f560e",
  measurementId: "G-52BNX17L58"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const db = getFirestore(app);
const storage = getStorage(app, 'gs://saloon-acaed.firebasestorage.app');
const auth = getAuth(app);
const analytics = getAnalytics(app);

export { app, db, storage, auth, analytics }; 